import { useGlobal } from '@jimmyboys/liita-ui/dist/components/GlobalContext'
import ExpandableWidget from 'components/ExpandableWidget/ExpandableWidget'

import styles from './widgets.module.sass'
import { RenderBodyParts } from 'components/cards/MedicalOpinionTriageCard/MedicalOpinionTriageCard'

const BodyPartInjuryTypeWidget = (props) => {
	const { data } = props
	const { process, latestTriage } = data
	const { i18n } = useGlobal()

	return (
		<ExpandableWidget
			className={styles['aside-widget']}
			titleAppearance='aside-widget'
			arrowPosition='right'
			heading='h5'
			title={i18n`Body part and injury type`}
			icon='file'
			expanded={false}
			expandable={
				!!process?.info?.bodyPartName || !!process?.info?.injuryTypeName
			}
			borderRadius
			margins={['small', '', '']}
			paddings={['xsmall', 'xsmall', 'xsmall']}
		>
			<RenderBodyParts
				bodyParts={latestTriage?.bodyParts}
				isRenderedInWidget={true}
			/>
		</ExpandableWidget>
	)
}

export default BodyPartInjuryTypeWidget
